import React from 'react';
import Media, { MediaProps } from '../Media';
import { CardTop, CardBottom } from '../CardPieces';
import { CardContentProps } from '../CardContent';

import CardBase from '../CardBase';
import cls from '@soluto-design/styles/cls';

export interface CardMediaLargeProps extends CardContentProps {
    media?: MediaProps['media'];
    booth?: string;
    location?: string;
    mediaWithFrame?: boolean;
}

export default function CardMediaLarge({
    tag,
    title,
    text,
    date,
    persons,
    media,
    mediaWithFrame,
    cta,
    location,
}: CardMediaLargeProps) {
    return (
        <CardBase
            href={cta?.href}
            className={cls(
                'md:min-h-[457px] lg:min-h-[465px] xl:min-h-[528px] flex flex-col md:flex-row overflow-hidden rounded-large bg-background-brand-primary',
                cta?.disabled && 'bg-background-disabled',
            )}>
            {media && (
                <div
                    className={cls(
                        'md:basis-[36%] lg:basis-1/2 md:grow md:h-auto w-full relative',
                        mediaWithFrame
                            ? 'p-24 md:p-32 lg:p-36 xl:p-40 md:!pr-0'
                            : 'bg-background-secondary h-[172px]',
                    )}>
                    {mediaWithFrame ? (
                        <div
                            className={cls(
                                'rounded-medium w-full h-full p-24 bg-background-disabled flex items-center justify-center',
                                media.src?.width > media.src?.height
                                    ? 'lg:px-[10%]'
                                    : 'lg:px-[25%]',
                            )}>
                            <Media
                                media={media}
                                className="w-full h-auto"
                                layout="responsive"
                            />
                        </div>
                    ) : (
                        <Media media={media} layout="fill" />
                    )}
                </div>
            )}
            <div className="md:basis-[64%] lg:basis-1/2 flex flex-col p-24 md:p-32 lg:p-36 xl:p-40 h-full">
                <CardTop
                    tag={tag}
                    title={title}
                    className="flex flex-col gap-lg pb-xs"
                />
                <CardBottom
                    text={text}
                    date={date}
                    cta={cta}
                    persons={persons}
                    location={location}
                    isLarge
                    className="flex flex-col grow justify-between gap-y-[40px]"
                />
            </div>
        </CardBase>
    );
}
